import React from 'react';
import { Flex, FlexProps } from '@radix-ui/themes';
import { NavigationTabsOption } from '@common/types/link';
import { useTabUrl } from '@common/hooks/useTabUrl';

interface NavigationTabsProps<T extends string>
    extends Omit<FlexProps, 'children'> {
    options: NavigationTabsOption<T>[];
    defaultValue?: T;
    children: React.ReactElement;
}

export const NavigationTabs = <T extends string>({
    options,
    defaultValue,
    children,
    ...props
}: NavigationTabsProps<T>) => {
    const { getTabState } = useTabUrl(options, defaultValue);

    return (
        <Flex align='center' gap='4' {...props}>
            {options.map((option) => {
                const computed = getTabState(option);

                return React.cloneElement(children, {
                    key: option.value,
                    ...computed,
                });
            })}
        </Flex>
    );
};
